
export function useToggleSelect(list, value, key) {
  let res = value ? list.value.map(item => item[key || 'id']) : []
  return res
}